import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { Link } from "react-router-dom";
import menudata from "./MenuData";

function MenuContainer() {
  var currentLocation = window.location.pathname;

  return (
    <MDBContainer fluid>
      <MDBRow className="Home">
        <MDBCol md="3">
          <Link to="/">
            <button className="btn btn-danger btn-lg">Home</button>
          </Link>
        </MDBCol>
        <MDBCol md="6" className="main1">
          <div className="dayed">
            {currentLocation === "/Monday" ? <span>MONDAY</span> : null}
            {currentLocation === "/Tuesday" ? <span>TUESDAY</span> : null}
            {currentLocation === "/Wednesday" ? <span>WEDNESDAY</span> : null}
            {currentLocation === "/Thursday" ? <span>THURSDAY</span> : null}
            {currentLocation === "/Friday" ? <span>FRIDAY</span> : null}
          </div>

          <div className="day1">
            {currentLocation === "/Monday" ? (
              <ul>
                {menudata.map(i => {
                  if (i.day === "Monday") {
                    return (
                      <div>
                        <li>{i.food}</li>
                        <li>{i.sauce}</li>
                        <li> {i.dish}</li>
                        <li> {i.sidedish} </li>
                        <li>{i.extras}</li>
                      </div>
                    );
                  }
                })}
              </ul>
            ) : null}
            {currentLocation === "/Tuesday" ? (
              <ul>
                {menudata.map(i => {
                  if (i.day === "Tuesday") {
                    return (
                      <div>
                        <li>{i.food}</li>
                        <li>{i.sauce}</li>
                        <li> {i.dish}</li>
                        <li> {i.sidedish} </li>
                        <li>{i.extras}</li>
                      </div>
                    );
                  }
                })}
              </ul>
            ) : null}
            {currentLocation === "/Wednesday" ? (
              <ul>
                {menudata.map(i => {
                  if (i.day === "Wednesday") {
                    return (
                      <div>
                        <li>{i.food}</li>
                        <li>{i.sauce}</li>
                        <li> {i.dish}</li>
                        <li> {i.sidedish} </li>
                        <li>{i.extras}</li>
                      </div>
                    );
                  }
                })}
              </ul>
            ) : null}
            {currentLocation === "/Thursday" ? (
              <ul>
                {menudata.map(i => {
                  if (i.day === "Thursday") {
                    return (
                      <div>
                        <li>{i.food}</li>
                        <li>{i.sauce}</li>
                        <li> {i.dish}</li>
                        <li> {i.sidedish} </li>
                        <li>{i.extras}</li>
                      </div>
                    );
                  }
                })}
              </ul>
            ) : null}
            {currentLocation === "/Friday" ? (
              <ul>
                {menudata.map(i => {
                  if (i.day === "Friday") {
                    return (
                      <div>
                        <li>{i.food}</li>
                        <li>{i.sauce}</li>
                        <li> {i.dish}</li>
                        <li> {i.sidedish} </li>
                        <li>{i.extras}</li>
                      </div>
                    );
                  }
                })}
              </ul>
            ) : null}
          </div>
        </MDBCol>

        <MDBCol md="3"></MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default MenuContainer;
